import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Image, Stack, Text, Title } from '@mantine/core';
import { IconCheck, IconShoppingBag } from '@tabler/icons-react';
import { THEME_COLORS } from '../../theme/ThemeConstants';
import { Footer } from '../../components/layout/Footer';
import { HeroBackdrop } from '../../components/background/HeroBackdrop';
import { getRuntimeEnvironment } from '@trappedmc/docker-frontend-runtime-env';

const { REACT_APP_FULL_URL = '' } = getRuntimeEnvironment();

export const SuccessView: React.FC = observer(() => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear any cart data from localStorage
    localStorage.removeItem('basket_ident');
    localStorage.removeItem('user_data');
  }, []);

  const handleReturnToStore = () => {
    navigate('/');
  };

  return (
    <>
      <HeroBackdrop imageUrl='/assets/images/hero.png' />
      <Box
        style={{
          backgroundColor: 'transparent',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          zIndex: 2
        }}
      >
      <Box
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24
        }}
      >
        <Container size='md'>
          <Stack align='center' gap={32}>
            {/* Logo */}
            <Image
              src={`${REACT_APP_FULL_URL}/assets/images/logo.png`}
              alt='Server Logo'
              style={{ width: 128, height: 128 }}
            />

            {/* Main Card */}
            <Box
              style={{
                backgroundColor: THEME_COLORS.background.secondary,
                border: `1px solid rgba(255, 255, 255, 0.06)`,
                borderRadius: 12,
                padding: 40,
                width: '100%',
                maxWidth: 480,
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
              }}
            >
              <Stack gap={24}>
                {/* Success Icon */}
                <Box
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    backgroundColor: `${THEME_COLORS.accent.primary}15`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <IconCheck size={28} color={THEME_COLORS.accent.primary} stroke={2.5} />
                </Box>

                {/* Main Heading */}
                <Stack gap={4}>
                  <Title
                    order={1}
                    c='white'
                    style={{
                      fontSize: 32,
                      fontWeight: 800,
                      lineHeight: 1.2,
                      letterSpacing: '-0.01em'
                    }}
                  >
                    Thank You!
                  </Title>
                  <Text size='16px' c={THEME_COLORS.text.secondary} fw={400}>
                    Your purchase was successful
                  </Text>
                </Stack>

                {/* Personal Message */}
                <Text size='14px' c={THEME_COLORS.text.secondary} lh={1.7}>
                  Your items will be delivered to your account shortly. Thank you for supporting our Anti-P2W network.
                </Text>

                {/* CTA Button */}
                <Button
                  leftSection={<IconShoppingBag size={16} />}
                  c='#ffffff'
                  style={{
                    backgroundColor: THEME_COLORS.accent.orange,
                    height: 40,
                    fontSize: 14,
                    fontWeight: 500,
                    paddingLeft: 24,
                    paddingRight: 24,
                    borderRadius: 6,
                    border: 'none',
                    transition: 'all 0.2s ease'
                  }}
                  onClick={handleReturnToStore}
                >
                  Return to Store
                </Button>
              </Stack>
            </Box>
          </Stack>
        </Container>
      </Box>

        <Footer />
      </Box>
    </>
  );
});
